export const API_PRX = {
  BILLING: '/billing',
} as const;
